exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-table[data-v-b014984c] {\n\t\tmargin-bottom: 20px;\n}\n.tables th[data-v-b014984c] {\n        border: none;\n}\n.button-page[data-v-b014984c] {\n        float:right;\n        margin-right: 0.5em;\n}\n.no-border[data-v-b014984c] {\n        border: hidden;\n        background: none;\n}\nth[data-v-b014984c] {\n        padding: 1em;\n}\ntd[data-v-b014984c] {\n        padding:1em;\n}\n", ""]);

// exports
